import './styles.css';
import React, { useEffect, useState } from "react";
//import { Dimmer, Loader } from 'semantic-ui-react';
import Weather from '../Weather/Weather';
//import Forecast from '../Weather/Forecast';
//import Swal from 'sweetalert2';
//import { fetchConToken } from "helpers/fetch";
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import classes from './WeatherMain.module.css';

import { useDispatch, useSelector } from 'react-redux';
import { fetchWeather } from '../../store/data-actions';

import moment from 'moment';
import 'moment/locale/es';

//import moment from 'moment';



export default function WeatherMain() {
  
  const dispatch = useDispatch();
  const {language} = useSelector( state => state.data); 
  
    
  const { weather, city } = useSelector( state => state.data);
  //const [lat, setLat] = useState(-2.068697);
  //const [long, setLong] = useState(-79.83206);
  //const [weatherData, setWeatherData] = useState(null);
    
  //const [city, setCity] = useState();

  useEffect(() => {
    //UPDATE PARA LEER DE MONGO DB CON REDUX desde panel de sensores
  
    dispatch( fetchWeather(language) );
   
  }, [])

  
  
  return (
    <div style={{display: "flex", justifyContent: 'flex-start', minHeight:'140px'}} >
      {(weather !== null) ? (
        <span style={{display: "flex", justifyContent: 'flex-start', flexWrap: "wrap"}}>
            <div style={{display: "flex", flexWrap: "wrap", width: '100%', padding: '2px', marginLeft: '10px', marginBottom: '5px'}}>
                <h4 >
                  {city} - &nbsp;
                </h4>
                
                <h5 > 
                 {moment.unix(weather.current.dt).locale(language).format("ll")}
                </h5>
           </div>
           <div style={{display: "flex", flexWrap: "wrap", justifyContent: "space-around",  width: '100%', padding: '5px', marginLeft: '10px', marginBottom: '5px'}}>
                <Weather weatherData={weather}/>
                 
           </div>

            
            
            
            
        </span>
      ): (
        <div className={classes.loading}>
              <LoadingSpinner />
        </div>
      )}
    </div>
  );
}